import { Button } from "./ui/button";

/**
 * "Continue with Google" button — kicks off the Emergent-managed Google OAuth.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.  Always derive the redirect from
 * `window.location.origin` so we land back on the exact origin the user
 * is visiting (preview vs production).
 */
export default function GoogleSignInButton({ label = "התחבר עם Google", testid = "google-signin-btn", onClickOverride = null }) {
  const start = () => {
    if (typeof onClickOverride === "function") {
      onClickOverride();
      return;
    }
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <Button
      type="button"
      onClick={start}
      variant="outline"
      className="w-full bg-white hover:bg-stone-50 border-stone-300 text-stone-800 font-semibold gap-2"
      data-testid={testid}
    >
      {/* Google "G" multi-coloured logo */}
      <svg className="h-4 w-4" viewBox="0 0 48 48" aria-hidden>
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29 35.5 26.6 36 24 36c-5.3 0-9.7-3.4-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.2 5.2C40.9 34.7 44 29.7 44 24c0-1.3-.1-2.4-.4-3.5z"/>
      </svg>
      {label}
    </Button>
  );
}
